<template>
  <div>
    <b-row class="mt-5">
        <b-col cols="3">

        </b-col>
        <b-col cols="6">

          <div class="jumbotron">
            <div v-if="pwdReset == false">
              <h2 class="mb-3">{{$t('general.title')}}</h2>
              <b-alert v-if="error" variant="danger" show>{{error}}</b-alert>

              <form @submit.prevent="login" class="login-form">
                  <div class="form-group">
                      <label for="username">
                        {{$t('general.username')}}
                      </label>
                      <input type="text" v-model="username" name="username" class="form-control" />
                  </div>
                  <div class="form-group">
                      <label htmlFor="password">
                          {{$t('general.password')}}
                      </label>
                      <input type="password" v-model="password" name="password" class="form-control" />
                  </div>
                  <div class="form-group">
                      <button class="btn btn-primary">
                          {{$t('general.login')}}
                      </button>
                  </div>
                  <p><b-link v-on:click.prevent="initializeResetPassword">Forgot password? Change password</b-link></p>
                  <p>You don't have an account yet? <a href="https://www.sci-fund.ai/registration" target="_blank">Register</a> or find a <a href="https://www.sci-fund.ai/plans-and-prices" target="_blank">fitting plan</a>.</p>
              </form>
            </div>
            <div v-if="pwdReset == true">
              <h2 >Reset password</h2>
              <div  v-if="successMsg">
                <b-alert class="mt-2" variant="success" show><span v-html="successMsg"></span></b-alert>
                <a href="mailto:support@sci-fund.ai" target="_blank">Need support?</a>
              </div>
              <div v-if="!successMsg">
                <div class="form-group">
                    <label for="email">
                      Email
                    </label>
                    <input type="text" v-model="email" name="email" class="form-control" />
                </div>
                <div class="form-group">
                    <button class="btn btn-primary" v-on:click.prevent="resetPassword">
                        Send
                    </button>
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="3">

        </b-col>
    </b-row>
</div>
</template>

<script>

export default {
    data () {
        return {
            username: '',
            password: '',
            error: '',
            pwdReset: false,
            email: '',
            successMsg: ''
        }
    },
    created: function () {
      if(this.authenticated ) {
        this.$router.replace("/");
      }

    },
    computed: {
      authenticated () {
        return this.$store.state.authenticated;
      }
    },
    methods: {
      login () {
        this.$http.post(process.env.VUE_APP_AUTH_URL, {
          "username": this.username,
          "password": this.password
        }).then(response => {
            if( response && response.body && response.body.id_token ) {
              this.error = '';
              this.$store.commit('setAuthToken', response.body.id_token);
              //this.$store.dispatch('fetchAccount');
              //this.$store.dispatch('fetchSavedSearches');
              //this.$store.dispatch('fetchHorizonTreemap');
              //this.$store.dispatch('fetchHorizonCalendar');
              //this.$store.dispatch('fetchHorizonBubbles');

              var path = (this.$router.currentRoute.query && this.$router.currentRoute.query.redirect ) ? this.$router.currentRoute.query.redirect : '/';


              if( path != '/' ) {
                this.$router.replace("/");
                this.$router.push(path);
              } else {
                this.$router.replace(path);
              }

            }
            else {
              this.error = "Connection not possible"
            }
        }, error => {
            this.$store.commit('removeAuthToken');
            if( error.body && error.body.title ) {
              this.error = error.body.title + ': ' + error.body.detail;
            }
            else {
              this.error = "Connection not possible"
            }
        })
      },
      initializeResetPassword() {
        this.pwdReset = true;
      },
      resetPassword() {
        this.$http.post(process.env.VUE_APP_API_URL + '/account/reset-password/init',
          this.email
        ).then(response => {
          //console.log(response);
          this.successMsg = "<p>A password reset message has been sent to your email address. Please click the link in that message to reset your password.</p> <p>If you do not receive an email within the next few minutes, please check your spam folder.</p>";
        }, error => {
          console.log(error);
        })
      }

    }
};
</script>

<style scoped>

</style>
